// extracted by mini-css-extract-plugin
module.exports = {"files":"AssetFilesDetails_files__1XaXu"};